import {
  Assessment,
  ComprehensiveAssessment,
  Event,
  ICCReview,
  Org,
  Player,
  Team,
  Tournament,
  User,
} from 'src/api';
import { MainMenuOption } from 'src/service/MainMenu';
import { AbstractUserRole } from 'src/service/UserPermission/AbstractUserRole';

export class ResearcherRole extends AbstractUserRole {
  canView(option: MainMenuOption): boolean {
    const allowed = [
      MainMenuOption.union,
      MainMenuOption.team,
      MainMenuOption.player,
      MainMenuOption.event,
      MainMenuOption.assessment,
      MainMenuOption.user,
      MainMenuOption.home,
      MainMenuOption.tournament,
      MainMenuOption.venue,
      MainMenuOption.iccreview,
    ];
    return allowed.includes(option);
  }

  // unions
   
  canViewUnion(union: Org): boolean {
    return true;
  }

  // teams
   
  canViewTeam(team: Team): boolean {
    return true;
  }

  // players
   
  canViewPlayer(player: Player): boolean {
    return true;
  }

  // events
   
  canCommentEvent(event: Event): boolean {
    return true;
  }

   
  canViewComprehensiveAssessment(assessment: ComprehensiveAssessment): boolean {
    return true;
  }

  // assessments
   
  canViewAssessment(assessment: Assessment): boolean {
    return true;
  }

  // users
   
  canViewUser(user: User): boolean {
    return true;
  }

  // tournaments
   
  canViewTournament(tournament: Tournament): boolean {
    return true;
  }

  // icc reviews
   
  canViewICCReview(review: ICCReview): boolean {
    return true;
  }
}
